// Import dependencies
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { initialiser } from '../../ramen-imports/utilitybelt';

const swiperSettings = {
  swiper: {
    // todo: tweak as needed
    // slidesPerView: 'auto',
    slidesPerView: 2,
    threshold: 10,
    // slidesPerGroup: 4,
    // watchOverflow: true,
    preventClicksPropagation: false,
    preventClicks: false,
    resistanceRatio: 0,
    breakpoints: {
      600: {
        slidesPerView: 3,
      },
      900: {
        slidesPerView: 6,
        preventInteractionOnTransition: true,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    modules: [Navigation],
  },
};

const defaultSettings = {
  showFiltersClass: 'u-flex-at-medium',
  hideFiltersWrapperClass: 'u-none',
};

class TicketSelector {
  constructor(config) {
    const { el, settings } = config;

    this.container = el;
    this.swiperInstance = null;
    this.settings = { settings, ...defaultSettings };
    this.form = el.querySelector('form');
    this.swiperSettings = { container: settings.passes, ...swiperSettings };
    this.passes = el.querySelector(settings.passes);
    this.passInputs = el.querySelectorAll(`${settings.passes} input`);
    this.showFilters = el.querySelector(settings.showFilters);
    this.showFiltersWrapper = el.querySelector(settings.showFiltersWrapper);
    this.closeFilters = el.querySelector(settings.closeFilters);
    this.resetFiltersBtn = el.querySelector(settings.resetFilters);
    this.filters = el.querySelector(settings.filters);
    this.mediaQuery = `(min-width: ${settings.breakpoint})`;
    this.options = el.querySelectorAll(settings.options);
    this.optionsMobile = el.querySelectorAll(settings.optionsMobile);
  }

  init = () => {
    this.initSwiper();
    this.bindEvents();
    this.disableInputs();
  };

  initSwiper = () => {
    this.swiperInstance = new Swiper(this.swiperSettings.container, this.swiperSettings.swiper);
  };

  disableInputs = () => {
    if (window.matchMedia(this.mediaQuery).matches) {
      // desktop
      this.optionsMobile.forEach((el) => el.setAttribute('disabled', ''));
      this.options.forEach((el) => el.removeAttribute('disabled'));
    } else {
      // mobile
      this.options.forEach((el) => el.setAttribute('disabled', ''));
      this.optionsMobile.forEach((el) => el.removeAttribute('disabled'));
    }
  };

  resetFilters = () => {
    this.filters.querySelectorAll('input[type="hidden"], input[type="checkbox"]')
      .forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.value = '';
      });

    this.filters.querySelectorAll('input[type="range"]')
      .forEach((el, i) => {
        if (i === 0) {
          // eslint-disable-next-line no-param-reassign
          el.value = el.min;
        } else {
          // eslint-disable-next-line no-param-reassign
          el.value = el.max;
        }
      });

    this.form.submit();
  };

  bindEvents = () => {
    // todo: css transition
    this.showFilters.addEventListener('click', (e) => {
      e.preventDefault();
      this.showFiltersWrapper.classList.add(this.settings.hideFiltersWrapperClass);
      this.filters.classList.remove(this.settings.showFiltersClass);
    });

    this.passInputs.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.form.submit();
      });
    });

    this.resetFiltersBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.resetFilters();
    });

    this.closeFilters.addEventListener('click', (e) => {
      e.preventDefault();
      this.showFiltersWrapper.classList.remove(this.settings.hideFiltersWrapperClass);
      this.filters.classList.add(this.settings.showFiltersClass);
    });

    window.addEventListener('resize', () => {
      this.disableInputs();
    });
  };
}

export default (settings) => initialiser(settings, TicketSelector);
